import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

const schema = yup.object({
  msg_id: yup.string(),
  subject: yup.string(),
  from_email: yup.string(),
  to_email: yup.string(),
  status: yup.string().oneOf(["delivered", "not_delivered"]),
  opens_count: yup.number(),
  clicks_count: yup.number(),
  last_event_time: yup.string(),
});

export default addKeyToFieldsRecursively(schema);
